<template>
  <v-card>
    <v-layout>
      <v-navigation-drawer v-model="navigation.shown">

        <v-list-item @click="goTo('/home/dashboard')" class="text-center" >
          <div class="text-center" v-if="getCurrentCompany != null">
            <img :src="getCurrentCompany.logo_thumb ? getFileServerUrl + getCurrentCompany.logo_thumb : '@/assets/image/logo.png'" class="logo"/>
          </div>
        </v-list-item>
        
        <v-list-item @click="goTo('/home/dashboard')" class="text-center bg-primary" >{{ module_name }}</v-list-item>
        <v-list  density="compact" nav>
          <template v-for="item in getNavbarItemsFeatures">
          <v-list-group :value="item.name" v-if="item.menu.length > 0">
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                :prepend-icon="item.icon"
                :title="item.name"
              ></v-list-item>
            </template>
              <template v-for="(child, i) in item.menu" >
                <router-link :to="child.link" class="text-decoration-none text-black" style="background-color: #B4B5B6 !important;">
                    <v-list-item                     
                      :key="i"
                      :value="child.name"
                      :title="child.name"
                      :prepend-icon="child.icon"
                      :active="activeMenuItem === child.name"
                      @click="unSelectButton(item.name, child.name)"
                      style="padding-inline-start: 20px !important;"
                      >
                    </v-list-item>
                </router-link>
              </template>
          </v-list-group>
        </template>
        </v-list>
      </v-navigation-drawer>
      
      <v-main style="height: 100vh"></v-main>
    </v-layout>
  </v-card>
</template>
<script>
  export default {
    props: ["navigation"],
    data: () => ({
        toggle: "Dashboard",
        module_name: "",
        prefix: '',
        activeMenuItem: null 
    }),
    
    created (){

    },
    watch: {
      '$route': {
          immediate: true,
          handler(to) {
              this.getNavbarItemsFeatures.forEach(item => {
                  item.menu?.forEach(child => {
                      if (child.link === to.path) {
                          this.activeMenuItem = child.name;
                          this.toggle = item.name;
                      }
                  });
              });
          }
      }
  },
    computed: {
      getNavbarItems(){
        return this.$store.getters.getNavbarItems
      },
      getCurrentCompany() {
        return this.$store.getters.getCurrentCompany;
      },
      getNavbarItemsFeatures() {
        const menu = JSON.parse(localStorage.getItem("menu")) || [];
        const prefix = this.prefix;
        const data = menu.filter(el => el.prefix == prefix);
        this.module_name = data[0]?.name || "";
        const subModules = data.flatMap(item => item.sub_module || []);
        this.loading = true;
        return subModules;
      },
      getFileServerUrl() {
          return this.$store.getters.getFileServerUrl;
      },
  },
    methods:{
      goTo(val) {
        this.$router.push({ path: val }).catch(err => {});
      },
      unSelectButton(parentName, childName){
        this.toggle = parentName;
        this.activeMenuItem = childName;
      }
    },
    mounted(){
        const first_segment = this.$route.path.split('/')[1] || '';
        if (first_segment == 'module') {
            this.prefix = this.$route.path.split('/')[2] || '';;
        }else {
            this.prefix = first_segment;
        }

    }, 
  }
</script>

<style>
  .v-list-item--density-compact.v-list-item--one-line {
      min-height: 35px !important;
  }

  .v-list-group__items .v-list-item {
      padding-inline-start: unset !important;
      padding-left: 5px !important;
  }

  .start-padding{
      padding-inline-start: 0px !important;
  }

  .v-list .v-list-item--nav:not(:only-child) {
      margin-bottom: 0px !important;
  }
</style>
